import React, { useState } from 'react';
import { Wallet, Plus, History, CreditCard, ArrowRight } from 'lucide-react';
import { TokenStore } from './TokenStore';
export const TokenWallet = () => {
  const [showTokenStore, setShowTokenStore] = useState(false);
  const [tokenType, setTokenType] = useState<'luv' | 'gems' | null>(null);
  const handleOpenTokenStore = (type: 'luv' | 'gems') => {
    setTokenType(type);
    setShowTokenStore(true);
  };
  const handlePurchase = (bundleId: string) => {
    // Here you would implement the actual purchase logic
    console.log(`Purchased bundle: ${bundleId}`);
    // For now, just close the token store
    setShowTokenStore(false);
  };
  // If token store is open, show it
  if (showTokenStore) {
    return <TokenStore onBack={() => setShowTokenStore(false)} onPurchase={handlePurchase} currentTokens={240} data-id="element-21405" />;
  }
  // Otherwise show the wallet
  return <section className="space-y-4" data-id="element-21406">
      <div className="flex items-center justify-between" data-id="element-21407">
        <h2 className="text-lg font-medium" data-id="element-21408">LuvTokens Wallet</h2>
        <button className="text-sm text-of-blue dark:text-white flex items-center gap-1" data-id="element-21409">
          <History size={14} data-id="element-21410" />
          <span data-id="element-21411">History</span>
        </button>
      </div>
      <div className="grid grid-cols-2 gap-4" data-id="element-21412">
        <div className="bg-white rounded-md border border-of-gray p-4" data-id="element-21413">
          <div className="flex items-center gap-2 mb-2" data-id="element-21414">
            <span className="text-of-text-primary text-xl" data-id="element-21415">💗</span>
            <h3 className="font-medium" data-id="element-21416">LuvTokens</h3>
          </div>
          <p className="text-2xl font-medium" data-id="element-21417">240</p>
          <div className="mt-3 flex items-center justify-between" data-id="element-21418">
            <p className="text-xs text-of-text-secondary" data-id="element-21419">Regular currency</p>
            <button onClick={() => handleOpenTokenStore('luv')} className="flex items-center gap-1 px-2 py-1 bg-of-blue dark:bg-faded-purple rounded text-xs text-white" data-id="element-21420">
              <Plus size={12} data-id="element-21421" />
              <span data-id="element-21422">Get More</span>
            </button>
          </div>
        </div>
        <div className="bg-white rounded-md border border-of-gray p-4" data-id="element-21423">
          <div className="flex items-center gap-2 mb-2" data-id="element-21424">
            <span className="text-of-text-primary text-xl" data-id="element-21425">💎</span>
            <h3 className="font-medium" data-id="element-21426">DesireGems</h3>
          </div>
          <p className="text-2xl font-medium" data-id="element-21427">15</p>
          <div className="mt-3 flex items-center justify-between" data-id="element-21428">
            <p className="text-xs text-of-text-secondary" data-id="element-21429">Premium currency</p>
            <button onClick={() => handleOpenTokenStore('gems')} className="flex items-center gap-1 px-2 py-1 bg-of-blue dark:bg-faded-purple rounded text-xs text-white" data-id="element-21430">
              <Plus size={12} data-id="element-21431" />
              <span data-id="element-21432">Get More</span>
            </button>
          </div>
        </div>
      </div>
    </section>;
};